import React, { useEffect, useState } from "react";
import { gettrip } from "../../../services/TransportService";
import { format } from "date-fns";
import Pagination from "../../Constant/Pagination";
import { Spinner, Offcanvas, Card } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Tripstop from "./Tripstop";
import Trippass from "./Trippass";
import { IoIosArrowForward, IoMdAddCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Tripdetails from "./Tripdetails";
import AddTripModal from "./AddTripModal";
import DebounceSearchInput from "../../Constant/DebounceSearchInput";
import { CancelRequest } from "../../../services/AxiosInstance";
import { renderTripDuration, useWindowWidth } from "../../../utilities";
import { FaInfoCircle, FaMapMarkerAlt, FaTicketAlt } from "react-icons/fa";
const parseTime = (timeStr) => {
  if (!timeStr) return null;
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  const now = new Date();
  now.setHours(hours, minutes, seconds || 0, 0);
  return now;
};

const TripList = ({ routeName, routeId, endtime }) => {
  const [listreload, setListreload] = useState(false);
  const handleListReload = () => {
    setListreload(!listreload);
  };
  const navigate = useNavigate();
  const width = useWindowWidth();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selecteddata, setSelecteddata] = useState(null);
  const [total, setTotal] = useState(0);
  const [tabtype, setTabtype] = useState("details");
  const [stopdata, setStopdata] = useState(null);
  const [passdata, setPassdata] = useState(null);
  const [addTripModalOpen, setAddTripModalOpen] = useState(false);
  const [param, setParam] = useState({
    query: "",
    page: "1",
    page_size: "10",
  });
  const getData = () => {
    gettrip(routeId, param)
      .then((res) => {
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [routeId, param, listreload]);

  const toggleAddTripModal = () => {
    setAddTripModalOpen(!addTripModalOpen);
  };

  const handleopen = () => {
    setTabtype("details");
    setOpen(true);
  };
  const handleclose = () => {
    setStopdata("");
    setTabtype("");
    setOpen(false);
    setSelecteddata(null);
  };

  const tabs = {
    stop: (
      <Tripstop
        id={selecteddata?.id}
        stopdata={stopdata}
        setStopdata={setStopdata}
        routeName={routeName}
      />
    ),
    pass: (
      <Trippass
        id={selecteddata?.id}
        passdata={passdata}
        setPassdata={setPassdata}
      />
    ),
    details: (
      <Tripdetails
        routeName={routeName}
        data={selecteddata}
        routeId={routeId}
        endtime={endtime}
        handleListReload={handleListReload}
      />
    ),
  };

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleNewTripCreate = (newTrip) => {
    getData();
    // if (newTrip === null) {
    //   return;
    // }
    // setData((prev) => [
    //   newTrip,
    //   ...(param.page_size === prev.length ? prev.slice(0, -1) : prev),
    // ]);
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
  return (
    <>
      <div className="card-content col-sep flex-fill">
        <Card.Header>
          <div className="d-flex align-items-center justify-content-between">
            <h3>Route Trips</h3>
            <div className="d-flex gap-2">
              <div>
                <DebounceSearchInput handleSearchChange={handleSearchChange} />
              </div>
              <button className="btn btn-primary" onClick={toggleAddTripModal}>
                <IoMdAddCircleOutline size={19} className="me-1" />
                Add Trip
              </button>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="p-0">
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : data.length === 0 ? (
            <div className="p-2 text-center">There are no records found.</div>
          ) : (
            <div className="table-responsive pb-2">
              <table className="table fs-6 mb-0">
                <thead className="custom-thead table-light">
                  <tr>
                    <th style={{ width: "180px" }}>Bus & Driver</th>
                    <th>Trip Duration</th>
                    <th>Shift</th>
                    <th>Passes</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, index) => {
                    const start = parseTime(row.start_time);
                    const end = parseTime(row.end_time);
                    const tripDuration =
                      start && end
                        ? `${format(start, "hh:mm a")} - ${format(
                            end,
                            "hh:mm a"
                          )}`
                        : "-";
                    const tripModeClass =
                      row?.trip_mode?.toLowerCase() === "pickup"
                        ? "text-bg-success-soft"
                        : "text-bg-info-soft";

                    return (
                      <tr key={index}>
                        <td>
                          <span
                            className="text-primary cursor-pointer fw-semibold"
                            onClick={() => navigate(`/bus/${row?.bus?.id}`)}
                          >
                            {row.bus?.number_plate || "N/A"}
                          </span>
                          <br></br>
                          <span
                            className="text-secondary cursor-pointer"
                            onClick={() =>
                              navigate(`/driver/${row?.driver?.id}`)
                            }
                          >
                            ({row.driver?.name || "N/A"})
                          </span>
                        </td>
                        <td>
                          <span>{renderTripDuration(start, end)}</span>
                          <br></br>{" "}
                          <span
                            className={`badge rounded-pill ${tripModeClass}`}
                          >
                            {row.trip_mode || "N/A"}
                          </span>
                        </td>
                        <td>
                          <span
                            className="text-primary cursor-pointer fw-semibold"
                            onClick={() => navigate(`/shift/${row?.shift?.id}`)}
                          >
                            {row.shift?.name || "N/A"}
                          </span>
                        </td>
                        <td>{row.total_pass ?? "N/A"}</td>

                        <td>
                          <button
                            onClick={() => {
                              setSelecteddata(row);
                              setTimeout(handleopen(), 200);
                            }}
                            className="btn btn-sm btn-outline-primary"
                          >
                            Details <IoIosArrowForward />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination Component (if needed) */}
          {!loading && data.length > 0 && (
            <div className="px-2 border-top">
              <Pagination
                currentPage={param.page}
                recordsPage={param.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </Card.Body>
      </div>
      <Offcanvas
        show={open}
        onHide={handleclose}
        placement="end"
        style={{
          width: width < 992 ? "100vw" : "450px",
        }}
      >
        <Offcanvas.Header className="py-1 ps-2 pe-4" closeButton>
          <div>
            <ul className="nav flex-row custom-sidebar-nav px-2">
              <li className="nav-item" onClick={() => setTabtype("details")}>
                <span
                  className={`nav-link ${
                    tabtype === "details" ? "active" : ""
                  }`}
                >
                  Details
                </span>
              </li>
              <li className="nav-item" onClick={() => setTabtype("stop")}>
                <span
                  className={`nav-link ${tabtype === "stop" ? "active" : ""}`}
                >
                  Stops
                </span>
              </li>
              <li className="nav-item" onClick={() => setTabtype("pass")}>
                <span
                  className={`nav-link ${tabtype === "pass" ? "active" : ""}`}
                >
                  Passes
                </span>
              </li>
            </ul>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-2">{tabs[tabtype]}</Offcanvas.Body>
      </Offcanvas>
      <AddTripModal
        modalOpen={addTripModalOpen}
        toggleModal={toggleAddTripModal}
        handleAfterSubmit={handleNewTripCreate}
        routeId={routeId}
        end_time={endtime}
      />
    </>
  );
};

export default TripList;
